import state from './moduleWebstoreSupplierState';
import mutations from './moduleWebstoreSupplierMutations';
import actions from './moduleWebstoreSupplierActions';
import getters from './moduleWebstoreSupplierGetters';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
